import { useEffect, useState } from "react";
import { useApiService } from "../shared/apiservice";
import { SoftwareDownload } from "../shared/types";

function parseSoftwareDownload(data: Record<string, unknown>): SoftwareDownload {
    return {
        version: String(data.version),
        build: Number(data.build),
        url: String(data.url),
    };
}

export function useSoftwareDownload(enabled: boolean) {
    const [softwareDownload, setSoftwareDownload] = useState<SoftwareDownload | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const apiService = useApiService();

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;

        async function fetchSoftware() {
            setLoading(true);
            setError(null);
            setSoftwareDownload(null);

            try {
                const response = await apiService.get("/software");
                if (!response.ok) {
                    if (!cancelled) {
                        setError("Could not load install link. Please try again.");
                    }
                    return;
                }
                const json = await response.json();
                if (!cancelled) {
                    setSoftwareDownload(
                        parseSoftwareDownload((json.data ?? json) as Record<string, unknown>)
                    );
                }
            } catch (err) {
                console.error(err);
                if (!cancelled) {
                    setError("Could not load install link. Please try again.");
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        fetchSoftware();

        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return { softwareDownload, error, loading };
}
